import { Image } from '@dtx-company/shared-components/src'
import { LayoutProps, layout } from 'styled-system'
import { spinner } from '../../assets'
import React from 'react'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const LoadingSpinnerContainer = styled.div`
  .spin {
    width: 24px;
    height: 24px;
    animation: ${spin} 1.8s linear infinite;
    ${layout}
  }
`

export const LoadingSpinner = (props: { iconSrc?: string } & LayoutProps): JSX.Element => {
  return (
    <LoadingSpinnerContainer {...props}>
      <Image src={props.iconSrc || spinner} className="spin" />
    </LoadingSpinnerContainer>
  )
}
